/*jshint esversion: 6 */
import '@js/generalJs';
import { createApp, App as Application } from 'vue';
import App from './../vue/App_Index.vue';


import Treeselect from "@zanmato/vue3-treeselect";
import "@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css";

const app = createApp(App)
app.component('treeselect', Treeselect)
app.mount('#app'); 